// extracted by mini-css-extract-plugin
export default {"container":"styles_container__axTXY","logo":"styles_logo__SCTza","swiper":"styles_swiper__nfAre"};